import { Component, OnInit, Input, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { BaseModalDirective } from '../../base-modal';
import { VerifyIdentityService } from '@app/services/verify-identity.service';
import { ModalService } from '@app/services/modal/modal.service';
declare let gtag: Function;

@Component({
  selector: 'nh-id-verification-pending',
  templateUrl: './id-verification-pending.component.html',
  styleUrl: './id-verification-pending.component.scss',
  standalone: false
})
export class IdVerificationPendingComponent extends BaseModalDirective implements OnInit, OnDestroy {
  @Input() hubReferenceNumber: string = '';
  @Input() usrId: string = '';
  @Input() ridpSourceCd: string = '';
  @Input() invIdentityVerify: boolean = false;
  isMobileUser: boolean = false;
  displayTimestampBanner: boolean = false;
  displayServiceDownError: boolean = false;
  bannerMinutesRemaining = 0;
  minutes = 0;
  bannerInterval: any;
  calledExperianForm!: FormGroup;
  displayInvestigateErrorBanner: boolean = false;

  constructor(
    protected modalRef: BsModalRef,
    protected builder: FormBuilder,
    protected router: Router,
    private verifyIdentityService: VerifyIdentityService,
    private modalService: ModalService,
    private cdr: ChangeDetectorRef
  ) {
    super(modalRef, builder);
  }

  ngOnInit(): void { 
    this.isMobileUser = sessionStorage.getItem('isMobileUser') === 'true' ? true : false;
    if(sessionStorage.getItem('ridpTimestamp') && !this.invIdentityVerify) {
      this.displayTimestampBanner = true;
      const ridpTimestamp = sessionStorage.getItem('ridpTimestamp')!;
      this.startBannerCountdown(ridpTimestamp);
    }
    this.calledExperianForm = new FormGroup({
      calledYes: new FormControl(),
      calledNo: new FormControl()
    });
  }

  onContinueWithIdProofing(): void {
    const payload = {
      hubReferenceNumber: this.hubReferenceNumber,
      usrId: this.usrId,
      ridpSourceCd: this.ridpSourceCd
    };

    this.verifyIdentityService.getRidpRecord(payload).subscribe({
      next: (data: any) => {  
        const successCodes = ['HS000000', 'HX005001', 'HE200024', 'HE200027', 'HX009000']
        if (data?.getRecordResponse?.idProofedResponse && successCodes.includes(data?.getRecordResponse?.responseMetadata?.responseCode)) {
          this.displayServiceDownError = false;
          const finalDecision = data?.getRecordResponse?.idProofedResponse?.finalDecisionCode?.toUpperCase();
          const hubReferenceNumber = data?.getRecordResponse?.idProofedResponse?.hubReferenceNumber;
          const timeStamp = data?.getRecordResponse?.ridpSubmittedTs;
          // Open appropriate modal based on finalDecision
          if (finalDecision === 'CONTINUE') {
                this.hide(true);
            this.modalService.openRidpSuccessModal().subscribe();
          } else if (finalDecision === 'INVESTIGAT') {
            this.hide(true);
            this.modalService.openRidpPendingModal(hubReferenceNumber, this.usrId, this.ridpSourceCd, true).subscribe();
          } else if (finalDecision === 'STOP') {
                this.hide(true);
            this.modalService.openRidpStopModal().subscribe();
          } else if (finalDecision === 'ERROR' || finalDecision === 'NODECISION') {
            if (this.invIdentityVerify) {
              this.displayInvestigateErrorBanner = true;
            } else {
              sessionStorage.setItem('ridpTimestamp', timeStamp);
              // Use setTimeout to update in next tick to avoid ExpressionChangedAfterItHasBeenCheckedError
              setTimeout(() => {
                this.displayTimestampBanner = true;
                this.startBannerCountdown(timeStamp);
              }, 0);
            }
          }
        } else if(!data?.getRecordResponse?.idProofedResponse || !successCodes.includes(data?.getRecordResponse?.responseMetadata?.responseCode)){
          this.displayServiceDownError = true;
        }
      },
      error: (error) => {
        console.error('getRidpRecord API error:', error);
        // Close current modal and show error modal
        this.hide(true);
        // this.modalService.openRidpErrorModal().subscribe();
      }
    });
  }

    displayCantVerifyBanner(): boolean {
     return this.displayTimestampBanner;
  }
    private calculateMinutesRemaining(timestamp: string): number {
    if (!timestamp) return 0;
    
    try {
      const submittedTime = new Date(timestamp).getTime();
      const currentTime = Date.now();
      const elapsedMinutes = Math.floor((currentTime - submittedTime) / (1000 * 60));
      const remainingMinutes = Math.max(0, 29 - elapsedMinutes);
      
      return remainingMinutes;
    } catch (error) {
      console.error('Error calculating minutes remaining:', error);
      return 0;
    }
  }

    private startBannerCountdown(timestamp: string) {
    //this.ridpTimestamp = timestamp;
    this.bannerMinutesRemaining = this.calculateMinutesRemaining(timestamp);
    this.minutes = this.bannerMinutesRemaining; // Sync minutes with remaining time
    
    // If time has already expired, don't show banner
    if (this.bannerMinutesRemaining <= 0) {
      this.stopBannerCountdown();
      return;
    }
    
    if (this.bannerMinutesRemaining > 0) {
      this.displayTimestampBanner = true;
      this.cdr?.detectChanges();
      
      // Update every minute
      this.bannerInterval = setInterval(() => {
        this.bannerMinutesRemaining = this.calculateMinutesRemaining(timestamp);
        this.minutes = this.bannerMinutesRemaining; // Update minutes property
        
        if (this.bannerMinutesRemaining <= 0) {
          this.stopBannerCountdown();
        }
      }, 60000); // Update every minute
    }
  }

  private stopBannerCountdown() {
    this.displayTimestampBanner = false;
    this.minutes = 0; // Reset minutes when countdown stops
    //this.hasScrolledToBanner = false; // Reset scroll flag
    if (this.bannerInterval) {
      clearInterval(this.bannerInterval);
      this.bannerInterval = null;
    }
  }

  onApplyNow(): void {
    this.hide(true);
    sessionStorage.setItem("appType", "AFB");
    this.router.navigateByUrl("/application/" + "NEW");
  }

  onGoToDashboard(): void {
    this.hide(true);
    if (this.displayTimestampBanner) {
      sessionStorage.removeItem('ridpdisplayInvestigatePopuponLoad');
    }
    gtag('event', 'ridp_iv_cd', {
      'event_category': 'ridp_identity_verification',
      'event_label': 'continue_to_dashboard'
    });
    this.router.navigate(['/user-profile', 'benefit-dashboard']);
  }

  onUploadDocuments(experianVerfCallSw: 'Y' | 'N'): void {
    const payload = {
      usrId: this.usrId,
      experianVerfCallSw: experianVerfCallSw
    };
    this.verifyIdentityService.investigateDocUpload(payload).subscribe({
      next: () => {
        this.hide(true);
        this.router.navigateByUrl("/verify-identity/uploadDocuments");
      },
      error: (error) => {
        console.error('investigateDocUpload API error:', error);
        this.hide(true);
      }
    });
  }

  onConfirmSelection(): void {
    const calledYes = this.calledExperianForm?.get('calledYes')?.value;
    const calledNo = this.calledExperianForm?.get('calledNo')?.value;
    if (calledYes === 'checked') {
      this.onContinueWithIdProofing();
      const payload = {
        usrId: this.usrId,
        experianVerfCallSw: 'Y'
      };
      this.verifyIdentityService.investigateDocUpload(payload).subscribe({
        error: (error) => {
          console.error('Background investigateDocUpload failed:', error);
        }
      });
    } else if (calledNo === 'checked') {
      this.onUploadDocuments('N');
    }
  }

  isConfirmDisabled(): boolean {
    const calledYes = this.calledExperianForm?.get('calledYes')?.value;
    const calledNo = this.calledExperianForm?.get('calledNo')?.value;
    return !(calledYes === 'checked' || calledNo === 'checked');
  }

  onCheckboxChange(checkboxName: string): void {
    if (checkboxName === 'calledYes') {
      this.calledExperianForm?.get('calledNo')?.setValue(null);
    } else if (checkboxName === 'calledNo') {
      this.calledExperianForm?.get('calledYes')?.setValue(null);
    }
  }

  ngOnDestroy() {
    // Clean up interval on component destroy
    if (this.bannerInterval) {
      clearInterval(this.bannerInterval);
    }
  }
}
